"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.subscribeSpaceEvent = exports.subscribeSpaceState = exports.subscribeSessionEvent = exports.subscribeSessionState = exports.getSpaceStateRows = exports.getSpaceState = exports.getSessionState = void 0;
require("isomorphic-fetch");
const get_base_url_1 = __importDefault(require("./get-base-url"));
const shorten_look_ups_1 = __importDefault(require("./shorten-look-ups"));
const signal_r_1 = __importDefault(require("../utils/signal-r"));
const fetch_data_1 = __importDefault(require("../utils/fetch-data"));
exports.getSessionState = (params) => {
    return fetch_data_1.default(`${get_base_url_1.default(params.dataResidency)}/session-state`, shorten_look_ups_1.default(params)).catch((err) => Promise.reject(`Failed to fetch session state. ${err.message}`));
};
exports.getSpaceState = (params) => {
    return fetch_data_1.default(`${get_base_url_1.default(params.dataResidency)}/space-state`, shorten_look_ups_1.default({
        tenantId: params.tenantId,
        spaceId: params.spaceId,
        dataResidency: params.dataResidency,
    }), {
        username: params.accessId,
        password: params.accessToken,
    }).catch((err) => Promise.reject(`Failed to fetch space state. ${err.message}`));
};
exports.getSpaceStateRows = (params) => {
    return fetch_data_1.default(`${get_base_url_1.default(params.dataResidency)}/space-state-rows`, shorten_look_ups_1.default({
        tenantId: params.tenantId,
        sessionId: params.sessionId,
        dataResidency: params.dataResidency,
    }), {
        username: params.accessId,
        password: params.accessToken,
    }).catch((err) => Promise.reject(`Failed to fetch space state rows. ${err.message}`));
};
exports.subscribeSessionState = (params) => __awaiter(void 0, void 0, void 0, function* () {
    const { url, accessToken } = yield fetch_data_1.default(`${get_base_url_1.default(params.dataResidency)}/subscribe-session-state?sessionId=${params.sessionId}`).catch((err) => Promise.reject(`Failed to subscribe to session state. ${err.message}`));
    return signal_r_1.default({
        name: 'subscribe-session-state',
        url,
        accessToken,
        defaultMethodNameToListen: 'sessionState',
        callback: params.callback,
    });
});
exports.subscribeSessionEvent = (params) => __awaiter(void 0, void 0, void 0, function* () {
    const { url, accessToken } = yield fetch_data_1.default(`${get_base_url_1.default(params.dataResidency)}/subscribe-session-event?sessionId=${params.sessionId}`).catch((err) => Promise.reject(`Failed to subscribe to session event. ${err.message}`));
    return signal_r_1.default({
        name: 'subscribe-session-event',
        url,
        accessToken,
        defaultMethodNameToListen: 'sessionEvent',
        callback: params.callback,
    });
});
exports.subscribeSpaceState = (params) => __awaiter(void 0, void 0, void 0, function* () {
    const { url, accessToken } = yield fetch_data_1.default(`${get_base_url_1.default(params.dataResidency)}/subscribe-space-state?spaceId=${params.spaceId}`, undefined, {
        username: params.accessId,
        password: params.accessToken,
    }).catch((err) => Promise.reject(`Failed to subscribe to space state. ${err.message}`));
    return signal_r_1.default({
        name: 'subscribe-space-state',
        url,
        accessToken,
        defaultMethodNameToListen: 'spaceState',
        callback: params.callback,
    });
});
exports.subscribeSpaceEvent = (params) => __awaiter(void 0, void 0, void 0, function* () {
    const { url, accessToken } = yield fetch_data_1.default(`${get_base_url_1.default(params.dataResidency)}/subscribe-space-event?spaceId=${params.spaceId}`, undefined, {
        username: params.accessId,
        password: params.accessToken,
    }).catch((err) => Promise.reject(`Failed to subscribe to space events. ${err.message}`));
    return signal_r_1.default({
        name: 'subscribe-space-event',
        url,
        accessToken,
        defaultMethodNameToListen: 'spaceEvent',
        callback: params.callback,
    });
});
